import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useState, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Switch,
  Menu,
} from '@mui/material';
// components
import { useNavigate } from 'react-router-dom';
import { CreateEventForm, UpdateEventForm } from '../components/modal';
import { deleteEvent, fetchEvents, updateEvent } from '../api/index';
// import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import PopupModal from '../components/modal/Popup';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'slug', label: 'Slug', alignRight: false },
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'poster', label: 'Poster', alignRight: false },
  { id: 'startDate', label: 'Start date', alignRight: false },
  { id: 'endDate', label: 'End date', alignCenter: true },
  { id: 'published', label: 'Published', alignRight: false },
  { id: 'ticket', label: 'Ticket', alignCenter: true },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (event) => event?.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function EventPage() {
  const [open, setOpen] = useState(null);

  const [openForm, setOpenForm] = useState(false);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [eventsList, setEventsList] = useState([]);

  const [event, setEvent] = useState('');

  const [statusResponse, setStatusReponse] = useState(null);

  const [openEdit, setOpenEdit] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setEventsList(await fetchEvents(navigate));
    })();
  }, [navigate]);

  const handleSwitch = async (_id, status, index) => {
    setEventsList([...eventsList.slice(0, index), { ...eventsList[index], ...status }, ...eventsList.slice(index + 1)]);
    await updateEvent(_id, status, setStatusReponse);
  };

  const handleOpenMenu = (event, _id) => {
    setEvent(_id);
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = eventsList.map((n) => n._id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleDeleteEvent = async (type, idEvent, setStatusReponse) => {
    if (type === 'edit') {
      setOpenEdit(true);
    } else {
      await deleteEvent(idEvent, setStatusReponse);
    }
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - eventsList.length) : 0;

  const filteredUsers = applySortFilter(eventsList, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;
  return (
    <>
      <Helmet>
        <title> Event | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Events
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => setOpenForm(true)}>
            New Event
          </Button>
        </Stack>

        <Card>
          <UserListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={eventsList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {eventsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const { _id, slug, name, description, poster, startDate, endDate, published, ticket } = row;
                    const selectedUser = selected.indexOf(slug) !== -1;
                    return (
                      <TableRow hover key={_id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                        <TableCell padding="checkbox">
                          <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                        </TableCell>

                        <TableCell component="th" scope="row" padding="none">
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {slug}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell align="left">{name}</TableCell>

                        <TableCell align="left">{description}</TableCell>

                        <TableCell align="left">{poster}</TableCell>

                        <TableCell align="left">{startDate}</TableCell>

                        <TableCell align="left">{endDate}</TableCell>

                        <TableCell align="left">
                          <Switch
                            inputProps={{ 'aria-label': 'Color switch demo' }}
                            color="secondary"
                            checked={published}
                            onChange={() =>
                              handleSwitch(
                                _id,
                                {
                                  published: !published,
                                },
                                index
                              )
                            }
                          />
                        </TableCell>

                        <TableCell align="center">{ticket.length}</TableCell>

                        <TableCell align="right">
                          <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, _id)}>
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={eventsList.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Menu
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        aria-haspopup="listbox"
        aria-controls="lock-menu"
      >
        <MenuItem onClick={() => handleDeleteEvent('edit', event, setStatusReponse)}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edit
        </MenuItem>

        <MenuItem sx={{ color: 'error.main' }} onClick={() => handleDeleteEvent('delete', event, setStatusReponse)}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem>
      </Menu>

      {/* Create Event Modal Form */}
      {openForm && <CreateEventForm open={openForm} setOpen={setOpenForm} />}
      {openEdit && (
        <UpdateEventForm open={openEdit} setOpen={setOpenEdit} eventId={event} seStatusUpdate={setStatusReponse} />
      )}

      {statusResponse !== null && <PopupModal status={statusResponse} setStatusRegister={setStatusReponse} />}
    </>
  );
}
